import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Divider,
  TextField,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Snackbar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  InputAdornment,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import ApiServices from "../../../../Utils/ApiServices/ApiServices";
import InvoiceGenerator from "./InvoiceGenerator";
// import QRCode from "qrcode.react";
import CryptoJS from "crypto-js";
import { AddCircleOutline, RemoveCircleOutline } from "@mui/icons-material";
import { getDecryptedAccessToken, getDecryptedUserType } from "../../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";
import AppointmentCardPaymentBill from "./AppointmentCardPaymentBill";

const GeneratedBill = ({ Billdata, onSuccess, patientData }) => {
    
    
  const services = Billdata.filter((item) => item.service_id !== null);
  const products = Billdata.filter((item) => item.product_id !== null);
  const totalAmount =
    Billdata.length > 0 ? parseFloat(Billdata[0].total_amount) : 0;
  const walletid = Billdata.length > 0 ? parseInt(Billdata[0].wallet_id) : 0;
  const Pid = Billdata.length > 0 ? parseInt(Billdata[0]?.pid) : 0;
  const LoginUserType = getDecryptedUserType();
  const AccessToken = getDecryptedAccessToken();
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PROMISE);
  const [snackBarMessage, setsnackBarMessage] = useState(false);
  const [snackBarMessageData, setsnackBarMessageData] = useState("");
  const [snackBarMessageType, setsnackBarMessageType] = useState("success");
  const handlesnackBarMessageClose = () => {
    setsnackBarMessage(false);
  };
  const [patientEncryptedData, setpatientEncryptedData] = useState("");
  const patientInfo = {
    patient_fname: patientData?.patient_fname,
    patient_lname: patientData?.patient_lname,
    patient_email: patientData?.patient_email,
    eid: Billdata[0]?.eid,
    bill_id: Billdata[0]?.bill_id,
  };

  useEffect(() => {
    const encryptedData = CryptoJS.AES.encrypt(
      JSON.stringify(patientInfo),
      process.env.REACT_APP_USER_ENC_DEC_KEY
    ).toString();
    const urlSafeEncryptedData = encryptedData
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");

    setpatientEncryptedData(urlSafeEncryptedData);
  }, [patientData]);

  const [SingleCardPaymentDialogOpen, setSingleCardPaymentDialogOpen] =
    useState(false);
  const handleSingleCardPaymentDialogOpen = () => {
    setSingleCardPaymentDialogOpen(true);
  };

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedRowDataType, setselectedRowDataType] = useState(null);
  const [editedQuantity, setEditedQuantity] = useState("");
  const [editedDiscount, setEditedDiscount] = useState("");

  const handleOpenDialog = (row, datatype) => {
    setselectedRowDataType(datatype);
    setOpenDialog(true);
    setSelectedRowData(row);
    setEditedQuantity(row.service_quantity || row.product_quantity || "");
    setEditedDiscount(row.service_discount || row.product_discount || "");
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRowData(null);
  };

  const handleUpdate = async () => {
    if (!selectedRowData) return;

    let endpoint = `/apis/default/api/appointment/${Billdata[0]?.bill_id}/billingweb/${selectedRowData.service_id}`;

    if (selectedRowDataType === "product") {
      endpoint = `/apis/default/api/appointment/${Billdata[0]?.bill_id}/billingwebProduct/${selectedRowData.product_id}`;
    }

    let updatedData = {
      service_quantity: editedQuantity,
      service_quantity_billing: editedQuantity,
      service_discount: editedDiscount,
      bill_id: Billdata.bill_id,
      service_id: selectedRowData.service_id,
    };

    if (selectedRowDataType === "product") {
      updatedData = {
        product_quantity: editedQuantity,
        product_discount: editedDiscount,
        bill_id: Billdata.bill_id,
        product_id: selectedRowData.product_id,
      };
    }

    try {
      await ApiServices.put(endpoint, updatedData, {
        Authorization: `Bearer ${AccessToken}`,
      });
      handleCloseDialog();
      onSuccess();
      setsnackBarMessage(true);
      setsnackBarMessageType("success");
      setsnackBarMessageData("Billing Data Updated successfully!");
      // Optionally, refresh the data or give feedback
    } catch (error) {
      console.error("Error updating data", error);
      onSuccess();
      setsnackBarMessage(true);
      setsnackBarMessageType("error");
      setsnackBarMessageData("Something Went Wrong.");
      // Optionally, show error message
    }
  };

  const handleDelete = async () => {
    if (!selectedRowData) return;

    let endpoint = `/apis/default/api/appointment/${Billdata[0]?.bill_id}/billingweb/${selectedRowData.service_id}`;

    if (selectedRowDataType === "product") {
      endpoint = `/apis/default/api/appointment/${Billdata[0]?.bill_id}/billingwebProduct/${selectedRowData.product_id}`;
    }

    try {
      await ApiServices.delete(endpoint, {
        Authorization: `Bearer ${AccessToken}`,
      });
      handleCloseDialog();
      onSuccess();
      setsnackBarMessage(true);
      setsnackBarMessageType("success");
      setsnackBarMessageData("Billing Data Deleted successfully!");
      // Optionally, refresh the data or give feedback
    } catch (error) {
      console.error("Error deleting data", error);
      onSuccess();
      setsnackBarMessage(true);
      setsnackBarMessageType("error");
      setsnackBarMessageData("Something Went Wrong.");
      // Optionally, show error message
    }
  };

  const [walletBalance, setWalletBalance] = useState(0);
  const [deductFromWallet, setDeductFromWallet] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let endpoint = `/apis/default/api/wallet/${walletid}`;

        if (LoginUserType === "Patient") {
          endpoint = `/apis/default/portal/wallet/${walletid}`;
        }

        const response = await ApiServices.get(endpoint, {
          Authorization: `Bearer ${AccessToken}`,
        });

        setWalletBalance(response.data.currentBalance);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [walletid, LoginUserType, AccessToken]);

  const [availablePackages, setAvailablePackages] = useState([]);

  console.log("availablePackagesavailablePackages", availablePackages);
  console.log("servicesservices", services);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let endpoint = `/apis/default/api/packageAssignments/${Pid}`;

        if (LoginUserType === "Patient") {
          endpoint = `/apis/default/portal/packageAssignments/${Pid}`;
        }

        const response = await ApiServices.get(endpoint, {
          Authorization: `Bearer ${AccessToken}`,
        });

        if (response.data && Array.isArray(response.data)) {
          setAvailablePackages(response.data);
        } else {
          setAvailablePackages([]);
        }
      } catch (error) {
        console.error("Error fetching available packages:", error);
        setAvailablePackages([]);
      }
    };
    fetchData();
  }, [Pid]);

  const [paymentMethod, setPaymentMethod] = useState("Single Card");
  const [cardAmount, setCardAmount] = useState(0);
  const [cashAmount, setCashAmount] = useState(0);
  const [dualCardAmount1, setDualCardAmount1] = useState(0);
  const [dualCardAmount2, setDualCardAmount2] = useState(0);
  const [tipOption, setTipOption] = useState("0");
  const [customTipAmount, setCustomTipAmount] = useState(0);

  const handlePaymentMethodChange = (event) => {
    setPaymentMethod(event.target.value);
    setCardAmount(0);
    setCashAmount(0);
    setDualCardAmount1(0);
    setDualCardAmount2(0);
    setTipOption("0");
    setCustomTipAmount(0);
  };

  const handleCardAmountChange = (event) => {
    let value = parseFloat(event.target.value) || 0;
    const maxAmount = totalAmount + parseFloat(customTipAmount);
    if (value > maxAmount) {
      value = maxAmount;
    }
    if (value < 0) {
      value = 0;
    }
    setCardAmount(value);
    setCashAmount(maxAmount - value - deductFromWallet);
  };

  const handleDualCardAmount1Change = (event) => {
    let value = parseFloat(event.target.value) || 0;
    const maxAmount = totalAmount + parseFloat(customTipAmount);
    if (value > maxAmount) {
      value = maxAmount;
    }
    if (value < 0) {
      value = 0;
    }
    setDualCardAmount1(value);
    setDualCardAmount2(maxAmount - value - deductFromWallet);
  };

  const handleTipOptionChange = (event) => {
    const option = event.target.value;
    setTipOption(option);
    if (option === "0") {
      setCustomTipAmount(0);
    } else if (option === "5" || option === "10" || option === "15") {
      const tipPercentage = parseFloat(option);
      const tipAmount = (totalAmount * tipPercentage) / 100;
      setCustomTipAmount(tipAmount);
    }
  };

  const handleCustomTipAmountChange = (event) => {
    let value = parseFloat(event.target.value) || 0;
    if (value < 0) {
      value = 0;
    }
    setCustomTipAmount(value);
  };

  const calculateTotalWithTip = () => {
    let tipAmount = parseFloat(customTipAmount) || 0;
    if (tipOption === "5" || tipOption === "10" || tipOption === "15") {
      tipAmount = (totalAmount * parseFloat(tipOption)) / 100;
    }
    return (totalAmount + tipAmount - deductFromWallet).toFixed(2);
  };
  const amountToPay = parseFloat(calculateTotalWithTip());

  const handleWalletDeductionChange = (event) => {
    let value = parseFloat(event.target.value) || 0;
    if (value < 0) {
      value = 0;
    }
    if (value > walletBalance) {
      value = walletBalance;
    }
    if (value > amountToPay) {
      value = amountToPay;
    }
    setDeductFromWallet(value);
    adjustPaymentAmounts(value);
  };

  const adjustPaymentAmounts = (walletAmount) => {
    const maxAmount = totalAmount + parseFloat(customTipAmount);
    setCardAmount(maxAmount - cashAmount - walletAmount);
    setCashAmount(maxAmount - cardAmount - walletAmount);
    setDualCardAmount1(maxAmount - dualCardAmount2 - walletAmount);
    setDualCardAmount2(maxAmount - dualCardAmount1 - walletAmount);
  };

  const handlePayment = async () => {
    try {
      const paymentMode =
        paymentMethod === "Single Card"
          ? "Wallet + Single Card"
          : "Wallet + Cash";
      const payload = {
        tip: customTipAmount,
        partialPayment: amountToPay,
        amount_after_tip: amountToPay,
        wallet_money: deductFromWallet,
        eid: Billdata[0]?.eid,
        pid: Billdata[0]?.pid,
        is_billed: 1,
        bill_id: Billdata[0]?.bill_id,
        modeOfPayment: [
          {
            PartialPaymentAmount: amountToPay + deductFromWallet,
            PartialPaymentMode: paymentMode,
          },
          {
            RemainingPaymentAmount: 0,
            RemainingPaymentMode: "",
          },
        ],
      };

      await ApiServices.put(`/apis/default/api/billingupdate`, payload, {
        Authorization: `Bearer ${AccessToken}`,
      });

      if (deductFromWallet > 0) {
        const walletTransactionData = {
          amount: deductFromWallet,
          description: `Deducted amount - ${deductFromWallet} against Appointment of Bill ID: ${Billdata[0]?.bill_id}`,
        };

        await ApiServices.put(
          `/apis/default/api/walletTransaction/${walletid}`,
          walletTransactionData,
          {
            Authorization: `Bearer ${AccessToken}`,
          }
        );
      }
      onSuccess();
      setsnackBarMessage(true);
      setsnackBarMessageType("success");
      setsnackBarMessageData("Payment processed successfully!");
    } catch (error) {
      onSuccess();
      setsnackBarMessage(true);
      setsnackBarMessageType("error");
      setsnackBarMessageData("Error processing payment.");
    }
  };
  const handleSingleCardPaymentDialogClose = () => {
    setSingleCardPaymentDialogOpen(false);
    handlePayment();
  };

  const handleQRCodeClick = () => {
    console.log("handleQRCodeClickhandleQRCodeClick Called");
    const paymentPageURL = `/appoint-ment-bill/${amountToPay}/${patientEncryptedData}`;
    const finalURL = `${paymentPageURL}`;
    window.open(finalURL, "_blank");
  };

const [open, setOpen] = useState(false);
const [selectedPackages, setSelectedPackages] = useState([]);
const [quantities, setQuantities] = useState({});
const [serviceQuantity, setServiceQuantity] = useState(0); // Add this state

const handleOpenPackageDialog = (service) => {
  const matchedPackages = availablePackages.filter(
    (pkg) => pkg.service_id === service.service_id
  );
  setSelectedPackages(matchedPackages);
  setServiceQuantity(service.service_quantity); // Set the service quantity
  setQuantities({}); // Reset quantities when opening dialog
  setOpen(true);
};

const handleClosePackageDialog = () => {
  setOpen(false);
  setSelectedPackages([]);
};

const handleQuantityChange = (pkgId, change) => {
  setQuantities((prevQuantities) => {
    const newQuantity = (prevQuantities[pkgId] || 0) + change;
    const matchedPackage = selectedPackages.find(
      (pkg) => pkg.assignment_id === pkgId
    );
    const totalUsedQuantity = Object.values(prevQuantities).reduce((sum, qty) => sum + qty, 0) + change;

    if (
      newQuantity >= 0 &&
      newQuantity <= Math.min(matchedPackage.service_quantity, matchedPackage.remaining_quantity) &&
      totalUsedQuantity <= serviceQuantity // Ensure total does not exceed service quantity
    ) {
      return { ...prevQuantities, [pkgId]: newQuantity };
    }
    return prevQuantities;
  });
};

  return (
    <div sx={{ padding: 0 }}>
      <TableContainer component={Paper} sx={{ padding: 0 }}>
        <Table sx={{ padding: 0 }}>
          <TableHead>
            <TableRow>
              <TableCell>Title</TableCell>
              <TableCell>Price</TableCell>
              <TableCell>Quantity</TableCell>
              <TableCell>Discount</TableCell>
              <TableCell>Total Amount</TableCell>
              {LoginUserType !== "Patient" &&
                Billdata &&
                Billdata[0]?.is_billed === 0 && <TableCell>Actions</TableCell>}
              {Billdata && Billdata[0]?.is_billed === 0 && (
                <TableCell>Package</TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell colSpan={5}>
                <Typography variant="h6" gutterBottom>
                  Services
                </Typography>
              </TableCell>
            </TableRow>
            {services.map((service, index) => (
              <TableRow key={index}>
                <TableCell>{service.service_title}</TableCell>
                <TableCell>{service.service_default_price}</TableCell>
                {/* <TableCell>{service.service_quantity}</TableCell> */}
                <TableCell>{service.service_quantity_billing}</TableCell>
                <TableCell>{service.service_discount}</TableCell>
                <TableCell>{service.service_total_amount}</TableCell>
                {LoginUserType !== "Patient" &&
                  Billdata &&
                  Billdata[0]?.is_billed === 0 && (
                    <TableCell>
                      <Button
                        onClick={() => handleOpenDialog(service, "service")}
                      >
                        Actions
                      </Button>
                    </TableCell>
                  )}
                {Billdata && Billdata[0]?.is_billed === 0 && (
                  <TableCell>
                    {availablePackages.some(
                      (pkg) => pkg.service_id === service.service_id
                    ) && (
                      <Button
                        onClick={() =>
                          handleOpenPackageDialog(service)
                        }
                      >
                        Package Available
                      </Button>
                    )}
                  </TableCell>
                )}
              </TableRow>
            ))}
            <TableRow>
              <TableCell colSpan={5}>
                <Typography variant="h6" gutterBottom>
                  Products
                </Typography>
              </TableCell>
            </TableRow>
            {products.map((product, index) => (
              <TableRow key={index}>
                <TableCell>{product.product_title}</TableCell>
                <TableCell>{product.product_default_price}</TableCell>
                <TableCell>{product.product_quantity}</TableCell>
                <TableCell>{product.product_discount}</TableCell>
                <TableCell>{product.product_total_amount}</TableCell>
                {LoginUserType !== "Patient" &&
                  Billdata &&
                  Billdata[0]?.is_billed === 0 && (
                    <TableCell>
                      <Button
                        onClick={() => handleOpenDialog(product, "product")}
                      >
                        Actions
                      </Button>
                    </TableCell>
                  )}
              </TableRow>
            ))}

            <TableRow>
              <TableCell colSpan={2} align="left">
                <Typography variant="h6">
                  Total Amount: {totalAmount.toFixed(2)}
                </Typography>
              </TableCell>
              {Billdata && Billdata[0]?.is_billed === 1 && (
                <>
                  <TableCell colSpan={2} align="center">
                    <Typography variant="h6">
                      Total Tip: {Billdata && Billdata[0]?.tip}
                    </Typography>
                  </TableCell>
                  <TableCell colSpan={2} align="right">
                    <Typography variant="h6">
                      Sub Total: {Billdata && Billdata[0]?.amount_after_tip}
                    </Typography>
                  </TableCell>
                </>
              )}
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={open} onClose={handleClosePackageDialog}  maxWidth="lg"
        fullWidth>
  <DialogTitle>Available Packages</DialogTitle>
  <DialogContent>
    {selectedPackages.map((pkg) => (
      <Table key={pkg.assignment_id}>
        <TableHead>
          <TableRow>
            <TableCell>Package Type</TableCell>
            <TableCell>Remaining Quantity</TableCell>
            <TableCell>Used Quantity</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>{pkg.package_type}</TableCell>
            <TableCell>{pkg.remaining_quantity}</TableCell>
            <TableCell>
              <TextField
                type="number"
                value={quantities[pkg.assignment_id] || 0}
                InputProps={{
                  inputProps: {
                    min: 0,
                    max: pkg.remaining_quantity,
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => handleQuantityChange(pkg.assignment_id, -1)}
                      >
                        <RemoveCircleOutline />
                      </IconButton>
                      <IconButton
                        onClick={() => handleQuantityChange(pkg.assignment_id, 1)}
                      >
                        <AddCircleOutline />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    ))}
  </DialogContent>
  <DialogActions>
    <Button onClick={handleClosePackageDialog} color="primary">
      Close
    </Button>
  </DialogActions>
</Dialog>


      <Divider sx={{ my: 2 }} />

      {Billdata && Billdata[0]?.is_billed === 0 && (
        <>
          <Typography variant="h6" gutterBottom>
            Payment Methods
          </Typography>

          <RadioGroup
            value={paymentMethod}
            onChange={handlePaymentMethodChange}
          >
            {LoginUserType !== "Patient" && (
              <FormControlLabel value="Cash" control={<Radio />} label="Cash" />
            )}
            <FormControlLabel
              value="Single Card"
              control={<Radio />}
              label="Single Card"
            />
            <FormControlLabel value="QR" control={<Radio />} label="QR" />
            <FormControlLabel
              value="Email Link"
              control={<Radio />}
              label="Email Link"
            />
            <FormControlLabel
              value="Card + Cash"
              control={<Radio />}
              label="Card + Cash"
              disabled
            />
            <FormControlLabel
              value="Dual Card"
              control={<Radio />}
              label="Dual Card"
              disabled
            />
          </RadioGroup>

          {(paymentMethod === "Cash" || paymentMethod === "Single Card") && (
            <Box>
              <FormControl fullWidth>
                <InputLabel id="tip-label">Tip Options</InputLabel>
                <Select
                  labelId="tip-label"
                  value={tipOption}
                  onChange={handleTipOptionChange}
                >
                  <MenuItem value="0">No Tip</MenuItem>
                  <MenuItem value="5">5% of Total</MenuItem>
                  <MenuItem value="10">10% of Total</MenuItem>
                  <MenuItem value="15">15% of Total</MenuItem>
                  <MenuItem value="custom">Custom Amount</MenuItem>
                </Select>
              </FormControl>

              {tipOption === "custom" && (
                <TextField
                  label="Custom Tip Amount"
                  type="number"
                  value={customTipAmount}
                  onChange={handleCustomTipAmountChange}
                  fullWidth
                />
              )}
            </Box>
          )}
          {customTipAmount > 0 && (
            <Typography variant="h6" gutterBottom>
              Tip Amount: $ {parseFloat(customTipAmount || 0).toFixed(2)}
            </Typography>
          )}

          <Typography variant="h6" gutterBottom>
            Available Wallet Balance: ${" "}
            {parseFloat(walletBalance || 0).toFixed(2)}
          </Typography>

          {paymentMethod === "Card + Cash" && (
            <Box>
              <TextField
                label="Card Amount"
                type="number"
                value={cardAmount}
                onChange={handleCardAmountChange}
                fullWidth
              />
              <TextField
                label="Cash Amount"
                type="number"
                value={cashAmount}
                disabled
                fullWidth
              />
              <TextField
                label="Wallet Deduction"
                type="number"
                value={deductFromWallet}
                onChange={handleWalletDeductionChange}
                fullWidth
              />
              <Button variant="contained" sx={{ mt: 2 }}>
                Pay {cardAmount}$ with Card
              </Button>
              <Button variant="contained" sx={{ mt: 2 }}>
                Pay {cashAmount}$ with Cash
              </Button>
            </Box>
          )}

          {paymentMethod === "Dual Card" && (
            <Box>
              <TextField
                label="First Card Amount"
                type="number"
                value={dualCardAmount1}
                onChange={handleDualCardAmount1Change}
                fullWidth
              />
              <TextField
                label="Second Card Amount"
                type="number"
                value={dualCardAmount2}
                disabled
                fullWidth
              />
              <TextField
                label="Wallet Deduction"
                type="number"
                value={deductFromWallet}
                onChange={handleWalletDeductionChange}
                fullWidth
              />
              <Button variant="contained" sx={{ mt: 2 }}>
                Pay {dualCardAmount1}$ with First Card
              </Button>
              <Button variant="contained" sx={{ mt: 2 }}>
                Pay {dualCardAmount2}$ with Second Card
              </Button>
            </Box>
          )}

          {paymentMethod === "QR" && (
            <>
              <TextField
                label="Wallet Deduction"
                type="number"
                value={deductFromWallet}
                onChange={handleWalletDeductionChange}
                fullWidth
              />
              {/* <Box>
                <Typography variant="h6">
                  Scan this QR code Pay the Bill
                </Typography>
                <QRCode
                  value={`${process.env.REACT_APP_FRONTEND_SERVERURL}/appoint-ment-bill/${amountToPay}/${patientEncryptedData}`}
                  onClick={handleQRCodeClick}
                  size={200}
                />
                <Typography variant="h6">Pay $ {amountToPay}</Typography>
              </Box> */}
            </>
          )}

          {paymentMethod === "Email Link" && (
            <TextField
              label="Amount to Pay"
              type="number"
              value={calculateTotalWithTip()}
              disabled
              fullWidth
            />
          )}

          {paymentMethod === "Cash" && (
            <Box>
              <TextField
                label="Wallet Deduction"
                type="number"
                value={deductFromWallet}
                onChange={handleWalletDeductionChange}
                fullWidth
              />
              <Button
                variant="contained"
                sx={{ mt: 2 }}
                onClick={handlePayment}
              >
                Pay {calculateTotalWithTip()}$ in Cash
              </Button>
            </Box>
          )}

          {paymentMethod === "Single Card" && (
            <Box>
              <TextField
                label="Wallet Deduction"
                type="number"
                value={deductFromWallet}
                onChange={handleWalletDeductionChange}
                fullWidth
              />
              <Button
                variant="contained"
                sx={{ mt: 2 }}
                onClick={handleSingleCardPaymentDialogOpen}
              >
                Pay {calculateTotalWithTip()}$ with Card
              </Button>
            </Box>
          )}
        </>
      )}

      <div
        style={{ marginTop: "10px", display: "flex", justifyContent: "right" }}
      >
        <InvoiceGenerator
          Billdata={Billdata}
          services={services}
          products={products}
          walletBalance={walletBalance}
          totalAmount={totalAmount}
          patientData={patientData}
        />
      </div>
      <Snackbar
        open={snackBarMessage}
        autoHideDuration={6000}
        onClose={handlesnackBarMessageClose}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handlesnackBarMessageClose}
          severity={snackBarMessageType}
        >
          {snackBarMessageData}
        </MuiAlert>
      </Snackbar>

      <Dialog
        open={SingleCardPaymentDialogOpen}
        maxWidth="lg"
        fullWidth
        // fullScreen={fullScreen}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            setSingleCardPaymentDialogOpen(false);
          }
        }}
        disableEscapeKeyDown
      >
        <DialogTitle>Enter Card Details</DialogTitle>
        <DialogContent>
          <Elements stripe={stripePromise}>
            <AppointmentCardPaymentBill
              patientData={patientData}
              amount={amountToPay}
              onSuccess={handleSingleCardPaymentDialogClose}
            />
          </Elements>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setSingleCardPaymentDialogOpen(false)}
            color="primary"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Update or Delete</DialogTitle>
        <DialogContent>
          <TextField
            label="Quantity"
            type="number"
            fullWidth
            value={editedQuantity}
            onChange={(e) => setEditedQuantity(e.target.value)}
            margin="dense"
          />
          <TextField
            label="Discount"
            type="number"
            fullWidth
            value={editedDiscount}
            onChange={(e) => setEditedDiscount(e.target.value)}
            margin="dense"
            // InputProps={{
            //   endAdornment: <InputAdornment position="end">%</InputAdornment>,
            // }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleUpdate}>Update</Button>
          <Button onClick={handleDelete}>Delete</Button>
          <Button onClick={handleCloseDialog}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default GeneratedBill;
